export type UserRole = string;

// Accept legacy client/session role names without changing database roles or IDs.
export function canonicalRole(role: string): UserRole {
  const code = role.toUpperCase();
  return code === "AGENT" ? "SALES_CONSULTANT" : code;
}

export function effectiveRole(
  primaryRole: UserRole,
  assignedRoles: readonly UserRole[] = [],
): UserRole {
  void assignedRoles; // Assigned roles contribute saved permissions, not an inferred primary identity.
  return canonicalRole(primaryRole);
}

export function hasOrganizationScope(granted: readonly string[] = []) {
  return granted.includes("access:organization");
}

export function hasAssignedRole(
  user: { role: string; roles?: readonly string[] },
  role: string,
) {
  return [user.role, ...(user.roles || [])].some(
    (value) => canonicalRole(value) === canonicalRole(role),
  );
}

export function consultantFollowUpsOnly(user: {
  permissions?: readonly string[];
}) {
  return !user.permissions?.includes("followups:view_history");
}
